<template>
  <div>
    <h5 class="text-center info-text">Elija el Productor para el cual desea crear el Lote y pulse en SIGUIENTE</h5>

    <div class="row justify-content-center mt-5">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label w-100">
            <span>Seleccione Productor</span>

            <button class="btn btn-link btn-sm btn-fill btn-wd float-right" @click="newProducer($event)">
              <i class="fas fa-plus"></i>&nbsp;Agregar Productor
            </button>
          </label>

          <el-autocomplete
            v-model="selectedEntity"
            v-validate="modelValidations.producer"
            :fetch-suggestions="querySearchAsync"
            name="producer"
            placeholder="Seleccione Productor (*)"
            @select="onSelectProducer"
          ></el-autocomplete>

          <small v-show="searchError !== ''" class="text-danger d-block">
            {{ searchError }}
          </small>

          <small v-show="producer.invalid" class="text-danger">
            {{ getError('producer') }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { Autocomplete, Select, Option } from 'element-ui';
import remoteAutocompleteMixin from '../../../mixins/remoteAutocompleteMixin';

export default {
  components: {
    [Select.name]: Select,
    [Autocomplete.name]: Autocomplete,
    [Option.name]: Option,
  },

  mixins: [remoteAutocompleteMixin],
  props: {
    selected: {
      type: Boolean,
      default: null,
    },
  },

  data() {
    return {
      selectedProducer: null,
      selectedEntity: null,
      producers: [],
      modelValidations: {
        producer: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['producer']),
  },

  created() {
    if (this.selected) {
      this.$services
        .resource('producers')
        .show(this.selected)
        .then((res) => res.data.data)
        .then((data) => {
          this.selectedEntity = data.businessName;
          this.selectedProducer = data.id;
        });
    }
  },

  methods: {
    onSelectProducer(item) {
      this.selectedProducer = item.id;
    },

    selectOptions() {
      return this.producers;
    },

    fetchData(query) {
      this.producers = [];

      return this.$services
        .resource('producers')
        .search({ query })
        .then((res) => res.data.data)
        .then((producers) => {
          this.checkResults(producers);
          this.producers = producers;
        });
    },

    newProducer(e) {
      this.$emit('newProducer', e);
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      return this.$validator.validateAll();
    },

    getSelected() {
      return this.producers.find((p) => this.selectedProducer === p.id);
    },
  },
};
</script>

<style scoped>
.el-autocomplete {
  width: 100%;
}
</style>
